<div class="player-wrapper"
  [class.playing]="videoPlaying"
  [class.starting]="showPlaybackStarting"
  [class.loading]="showLoadingSpinner">
  <div class="video-content">
    <ng-content></ng-content>
  </div>

  @if (showThumbnail) {
    <img
      class="video-thumbnail"
      [src]="thumbnailUrl()"
      (error)="onThumbnailError()"
      alt="" />
  }

  @if (showLoadingSpinner) {
    <div class="loading-overlay" role="status" aria-busy="true">
      <span class="loading-spinner" aria-hidden="true"></span>
    </div>
  }

  <div class="video-overlay">
    <!-- Top spacer (keeps center centered with space-between) -->
    <div class="overlay-top"></div>

    <!-- Center: Skip back / Play|Pause / Skip forward -->
    <div class="overlay-center" [class.paused]="!videoPlaying || isEnded">
      <button class="overlay-btn skip-btn"
        [disabled]="controlsDisabled"
        (click)="seekRelative(-10)" aria-label="10秒戻す">
        <mat-icon>replay_10</mat-icon>
      </button>
      <button class="overlay-btn primary"
        [disabled]="controlsDisabled"
        (click)="togglePlay()" aria-label="再生/一時停止">
        @if (showPlaybackStarting) {
          <span class="overlay-spinner" aria-hidden="true"></span>
        } @else {
          <mat-icon [class.replay-spin]="replaySpin">
            {{ isEnded ? 'replay' : (videoPlaying ? 'pause' : 'play_arrow') }}
          </mat-icon>
        }
      </button>
      <button class="overlay-btn skip-btn"
        [disabled]="controlsDisabled"
        [style.visibility]="isEnded ? 'hidden' : 'visible'"
        (click)="seekRelative(10)" aria-label="10秒進む">
        <mat-icon>forward_10</mat-icon>
      </button>
    </div>

    <!-- Bottom: Time, Speed, Mute, Fullscreen -->
    <div class="overlay-bottom">
      <span class="time-label">
        {{ formatTime(videoCurrentTime) }} / {{ formatTime(videoDuration) }}
      </span>
      <div class="controls-inline">
        <button class="overlay-btn text-button"
          [disabled]="controlsDisabled"
          (click)="cycleRate()" aria-label="再生速度を切り替え">
          x{{ videoPlaybackRate | number:'1.0-2' }}
        </button>
        <button class="overlay-btn icon-plain"
          [disabled]="controlsDisabled"
          (click)="toggleMute()" aria-label="ミュート切替">
          <mat-icon>{{ videoMuted ? 'volume_off' : 'volume_up' }}</mat-icon>
        </button>
        <button class="overlay-btn icon-plain"
          [disabled]="controlsDisabled"
          (click)="toggleFullscreen()" aria-label="全画面">
          <mat-icon>fullscreen</mat-icon>
        </button>
      </div>
    </div>

  </div>

  <!-- Progress rail: outside overlay so it stays interactive during playback -->
  <div class="progress-rail"
    [class.active]="dragging || !videoPlaying"
    [class.dragging]="dragging"
    [class.disabled]="controlsDisabled"
    (pointerdown)="onRailPointerDown($event)"
    (touchstart)="onRailTouchStart($event)">
    <div class="progress-bar" [style.width.%]="progressPercent">
      <span class="progress-thumb"></span>
    </div>
  </div>
</div>
